import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../utils/translations';
import {ReservationTrackerIcon} from './ReservationTrackerIcon/ReservationTrackerIcon';
import {ALARM__24} from '@homeaway/svg-defs/lib/defs/ALARM__24';
import {DOWNLOAD__24} from '@homeaway/svg-defs/lib/defs/DOWNLOAD__24';
import {HOUSE__24} from '@homeaway/svg-defs/lib/defs/HOUSE__24';
import {appDownloadSelected} from '../../../../../utils/edapUtils';

import './ReservationTracker.less';

export class ReservationTracker extends React.PureComponent {
    static propTypes = {
        actionLocation: PropTypes.string,
        translations: PropTypes.shape({}).isRequired,
    };

    static defaultProps = {
        translations: {},
    };

    handleDownloadAppClick = (e) => {
        const {actionLocation} = this.props;
        // The event should fire only when the user clicks on the link
        if (e.target.tagName === 'A') {
            appDownloadSelected({actionLocation});
        }
    };

    render() {
        const {translations} = this.props;

        return (
            <div className="reservation-tracker">
                <ReservationTrackerIcon
                    icon={ALARM__24}
                    index={1}
                    text={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.request.tracker.accept'
                    )}
                />
                <ReservationTrackerIcon
                    onADownloadClick={this.handleDownloadAppClick}
                    icon={DOWNLOAD__24}
                    index={2}
                    text={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.request.tracker.download'
                    )}
                />
                <ReservationTrackerIcon
                    icon={HOUSE__24}
                    index={3}
                    text={translate(
                        translations,
                        'trav-dash/trav-home',
                        'messages',
                        'th.confirmation.request.tracker.status'
                    )}
                />
            </div>
        );
    }
}
